import WixSDK from 'shared/utils/wix-sdk';
import { createAction } from 'redux-actions';
import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import wrapAsyncCall from 'shared/redux/helpers/wrap-async-call';
import * as cashier from 'api/payments/cashier';
import * as dgs from 'api/payments/dgs';

export const CREATE_ORDER = createAsyncActions('PAYMENT.CREATE_ORDER');
export const INIT_SDK = createAsyncActions('PAYMENT.INIT_SDK');
export const SELECT_METHOD = createAction('PAYMENT.SELECT_METHOD');

export const CONFIGURE = createAction('PAYMENT.CONFIGURE');

export const statusChange = createAction('PAYMENT.STATUS_CHANGE');

export const setError = createAction('PAYMENT.ERROR');

export const fetchPaymentConfig = () => dispatch =>
  dgs.getConfig(WixSDK.Utils.getInstance())
    .then(
      response => dispatch(CONFIGURE(response)),
      error => dispatch(setError(error))
    );

export const createOrder = wrapAsyncCall(CREATE_ORDER, dgs.createOrder, (paymentType, channelId, videoId) => ({
  instance: WixSDK.Utils.getInstance(),
  paymentType, channelId, videoId,
}));

export const initSDK = wrapAsyncCall(INIT_SDK, cashier.configureSDK, ({ orderId }) => ({
  orderId,
  appDefId: WixSDK.Utils.getInstanceValue('appDefId'),
  instance: WixSDK.Utils.getInstance(),
  instanceId: WixSDK.Utils.getInstanceId(),
  locale: WixSDK.Utils.getLocale(),
}));

export const selectPaymentMethod = paymentMethod => SELECT_METHOD(paymentMethod);

export const clearPaymentMethod = () => SELECT_METHOD(null);




// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/payment.js